import { useState } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { T } from "@/i18n";

export const Navbar = ({ lang, onRegister, theme, onToggleTheme }) => {
  const [open, setOpen] = useState(false);
  const links = [
    { key: "details", href: "#details" },
    { key: "speakers", href: "#speakers" },
    { key: "worship", href: "#worship" },
    { key: "fee", href: "#fee" },
    { key: "contact", href: "#contact" },
  ];
  return (
    <header data-testid="main-navbar" className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#0B1233]/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <a href="#top" data-testid="nav-logo" className="font-display text-lg tracking-widest text-[#FFE500]">
          GLORY <span className="text-white">CONFERENCE</span>
        </a>
        <nav className="hidden items-center gap-6 md:flex">
          {links.map((l) => (
            <a key={l.key} data-testid={`nav-link-${l.key}`} href={l.href}
              className="text-sm text-white/70 transition-colors hover:text-[#FFE500]">
              {T.nav[l.key][lang]}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="theme-toggle"
            onClick={onToggleTheme}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-[#FFE500]/40 text-[#FFE500] transition-colors hover:bg-[#FFE500] hover:text-[#0B1233]"
            aria-label={theme === "light" ? "Switch to dark theme" : "Switch to light theme"}
          >
            {theme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
          </button>
          <button
            data-testid="nav-register-btn"
            onClick={onRegister}
            className="hidden rounded-full bg-[#FFE500] px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-[#0B1233] transition-transform hover:scale-105 sm:block"
          >
            {T.nav.register[lang]}
          </button>
          <button
            data-testid="mobile-menu-btn"
            className="text-white md:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-nav" className="border-t border-white/10 bg-[#0B1233] px-4 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.key} data-testid={`mobile-nav-link-${l.key}`} href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm text-white/80 hover:text-[#FFE500]">
                {T.nav[l.key][lang]}
              </a>
            ))}
            <button
              data-testid="mobile-register-btn"
              onClick={() => { setOpen(false); onRegister(); }}
              className="mt-2 rounded-full bg-[#FFE500] px-4 py-2 text-sm font-bold uppercase text-[#0B1233]"
            >
              {T.nav.register[lang]}
            </button>
          </div>
        </nav>
      )}
    </header>
  );
};
